export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAYAAABSgIzaAAAAGklEQVQokWNUTV70n4EMwESOplGNoxrJ1wgA4cYCQeRyCSUAAAAASUVORK5CYII="